// extracted by mini-css-extract-plugin
export default {"faq_separator":"Production_faq_separator__OGM3h","cooperation_separator":"Production_cooperation_separator__GTXtn"};